const API_ROOT = {
  development: 'http://api-test.aimoox.com',
  test: 'http://api-test.aimoox.com',
  production: 'http://api.aimoox.com',
}

const API_ROOT_COMMUNITYGOVERN = {
  development: 'http://test-shortvideo-api.szsttkj.com',
  test: 'http://test-shortvideo-api.szsttkj.com',
  production: 'https://api-shortvideo-xc.szxlxzb.com',
}

const API_PREFIX = '/api'

// 扩展 - 目前未使用
const API_PREFIX_COMMUNITYGOVERN = `${API_PREFIX}/communitygovern`

const proxyMatch = new RegExp(`^${API_PREFIX}`)

const proxyMatchCommunitygovern = new RegExp(`^${API_PREFIX_COMMUNITYGOVERN}`)

const roots2Proxies = (env) => [
  {
    match: proxyMatchCommunitygovern,
    map: (path) => path.replace(API_PREFIX_COMMUNITYGOVERN, '/communitygovern'),
    host: API_ROOT_COMMUNITYGOVERN[env],
  },
  {
    match: proxyMatch,
    map: (path) => path.replace(API_PREFIX, ''),
    host: API_ROOT[env],
  },
]
module.exports = {
  project: 'pixelMuse-h5',
  devPort: 9100,
  devStaticPort: 9101,
  scriptsConfig: {
    disableAutoImportAntdMobileCss: false,
  },
  production: {
    ENV: 'production',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
